import { useEffect } from 'react';
import './AdminReport.scss';

const url = process.env.REACT_APP_RETHINK_REPORT_URL;
const AdminReport = () => {
  useEffect(() => {
    window.location.replace(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export default AdminReport;
